import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import ResetPassword from '../../components/pages/ResetPassword';
import FullPageLayout from '../../components/layouts/FullPageLayout';
import Spinner from '../../components/common/Spinner';
import Token from '../../utils/token';
import { alertSuccess } from '../../store/actions/alert';
import { sendEmailPassword } from '../../store/actions/forgot';
import { signInFlow } from '../../store/actions/auth';
import { VALIDATED } from '../../constants/auth';

function ResetPasswordContainer(props) {
  const { currentStep, signInFlow } = props;

  const signedIn = useMemo(() => {
    const tokenExpiration = Token.getTokenExpiration();
    const tokenValid = new Date() < tokenExpiration;
    return tokenValid && currentStep === VALIDATED;
  }, [currentStep]);

  useEffect(() => {
    if (signedIn) {
      signInFlow();
    }
  }, [signedIn, signInFlow]);

  if (signedIn) {
    return <Spinner />;
  }

  return (
    <FullPageLayout>
      <ResetPassword {...props} />
    </FullPageLayout>
  );
}

const mapStateToProps = (state, ownProps) => {
  const query = new URLSearchParams(ownProps.location.search);

  return {
    email: query.get('email') || '',
  };
};

const mapDispatchToProps = (dispatch) => ({
  alertSuccess: (message) => dispatch(alertSuccess(message)),
  sendEmailPassword: (email) => dispatch(sendEmailPassword(email)),
  signInFlow: () => dispatch(signInFlow()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordContainer);
